import {
  FULL_SERVICE,
  GLOBAL_CATALOGS,
} from '../../types';

const initialState = {
  tabs: [],
  isLoading: false,
  announcement: {
    list: [],
    total: 0,
    page: 1,
    rowsPerPage: 10,
    pages: 10,
  },
  order: {
    list: [],
    total: 0,
    page: 1,
    rowsPerPage: 10,
    pages: 10,
  },
  details: {},
};

const repairReducer = function (state = initialState, action) {
  switch (action.type) {
    case FULL_SERVICE.Repair.Loading: {
      return {
        ...state,
        isLoading: action.payload
      };
    }
    case FULL_SERVICE.Repair.Value: {
      return {
        ...state,
        value: action.payload
      };
    }
    case GLOBAL_CATALOGS.Repair.Service: {
      return {
        ...state,
        tabs: action.payload
      };
    }
    case GLOBAL_CATALOGS.Repair.Announcement.List: {
      return {
        ...state,
        announcement: { ...action.payload }
      };
    }
    case GLOBAL_CATALOGS.Repair.Order.List: {
      return {
        ...state,
        order: { ...action.payload }
      };
    }
    default: {
      return state;
    }
  }
};

export default repairReducer;
